import type { InfractionMetricsSummary } from "../types/infraction.types";
import type { InfractionSummaryApiResponse } from "../types/infraction-api.types";

export function mapInfractionSummary(
	response: InfractionSummaryApiResponse
): InfractionMetricsSummary {
	return {
		criticalCount: response.criticalCount,
		awaitingIndicationCount: response.awaitingDriverIndicationCount,
		nicRiskAmount: response.nicRiskAmount,
		pendingTotalAmount: response.pendingTotalAmount,
	};
}
